"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    placeholderSelectText: {
      type: String,
      default: '请选择'
    },
    placeholderText: {
      type: String,
      default: '搜索'
    },
    leftAllLabel: {
      type: String,
      default: '全部'
    },
    rightAllLabel: {
      type: String,
      default: '全部'
    },
    leftTitle: {
      type: String,
      default: ''
    },
    rightTitle: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * label
     * value
     * key
     * selected
     */
    setData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterKey: {
      type: String,
      default: ''
    },
    filterOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isOriginVal: {
      type: Boolean,
      default: false
    },
    cHeight: {
      type: Number,
      default: 330
    },
    iHeight: {
      type: Number,
      default: 30
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      dataReady: false,
      loadingComponent: null,
      dataSourceList: [],
      contentHeight: 330,
      itemHeight: 30,
      startIndex: 0,
      allDataList: [],
      filterOption: [],
      dataSearch: '',
      isCheckAll: false,
      checkList: [],
      startIndex_select: 0,
      allDataList_select: [],
      filterOption_select: [],
      dataSearch_select: '',
      isCheckAll_select: false,
      checkList_select: [],
      currItem: {},
      currFocusItem: {}
    };
  },
  computed: {
    dataList: function dataList() {
      return this.filterDataList.slice(this.startIndex, this.startIndex + this.contentHeight / this.itemHeight + 10); // 多获取10个预加载项
    },
    filterDataList: function filterDataList() {
      var _this = this;
      var tmpList = (0, _toConsumableArray2.default)(this.allDataList);
      if (this.filterOption && this.filterOption.length) {
        tmpList = tmpList.filter(function (item) {
          return _this.filterOption.includes(item[_this.filterKey]);
        });
      }
      if (this.dataSearch) {
        tmpList = tmpList.filter(function (item) {
          return item.label.includes(_this.dataSearch);
        });
      }
      return (0, _toConsumableArray2.default)(tmpList);
    },
    dataList_select: function dataList_select() {
      return this.filterDataList_select.slice(this.startIndex_select, this.startIndex_select + this.contentHeight / this.itemHeight + 10); // 多获取10个预加载项
    },
    filterDataList_select: function filterDataList_select() {
      var _this2 = this;
      var tmpList = (0, _toConsumableArray2.default)(this.allDataList_select);
      if (this.filterOption_select && this.filterOption_select.length) {
        tmpList = tmpList.filter(function (item) {
          return _this2.filterOption_select.includes(item[_this2.filterKey]);
        });
      }
      if (this.dataSearch_select) {
        tmpList = tmpList.filter(function (item) {
          return item.label.includes(_this2.dataSearch_select);
        });
      }
      return (0, _toConsumableArray2.default)(tmpList);
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    setData: function setData(newValue) {
      if (newValue) {
        this.dataInit();
      }
    }
  },
  created: function created() {
    this.setInit();
  },
  mounted: function mounted() {},
  methods: {
    filterInit: function filterInit() {
      this.dataSearch = '';
      this.dataSearch_select = '';
      this.isCheckAll = false;
      this.isCheckAll_select = false;
      this.checkList = [];
      this.checkList_select = [];
    },
    setInit: function setInit() {
      this.contentHeight = this.cHeight;
      this.itemHeight = this.iHeight;
    },
    dataInit: function dataInit() {
      var _this3 = this;
      this.dataSourceList = this.setData.map(function (item) {
        return (0, _objectSpread2.default)({}, item);
      });
      this.filterInit();
      this.allDataList = [];
      this.allDataList_select = [];
      this.dataSourceList.forEach(function (item) {
        if (item.selected) {
          _this3.allDataList_select.push(item);
        } else {
          _this3.allDataList.push(item);
        }
      });
      this.dataReady = true;
    },
    handleScroll: function handleScroll(flag) {
      this["startIndex".concat(flag)] = Math.floor(this.$refs["content-box".concat(flag)].scrollTop / this.itemHeight);
    },
    handleCheckAll: function handleCheckAll(flag) {
      if (this["isCheckAll".concat(flag)]) {
        this["checkList".concat(flag)] = (0, _toConsumableArray2.default)(this["filterDataList".concat(flag)]).map(function (item) {
          return item.value;
        });
      } else {
        this["checkList".concat(flag)] = [];
      }
    },
    handleCheck: function handleCheck(flag) {
      var arr1 = (0, _toConsumableArray2.default)(this["checkList".concat(flag)]).sort();
      var arr2 = (0, _toConsumableArray2.default)(this["filterDataList".concat(flag)]).map(function (item) {
        return item.value;
      }).sort();
      if (arr1.toString() === arr2.toString() && arr1.toString()) {
        this["isCheckAll".concat(flag)] = true;
      } else {
        this["isCheckAll".concat(flag)] = false;
      }
    },
    L2R: function L2R() {
      var _this4 = this;
      if (!this.checkList.length) return;
      this.isLoading = true;
      setTimeout(function () {
        // setTimeout延时避免加载图标显示不出来
        _this4.allDataList = [];
        _this4.allDataList_select = [];
        _this4.dataSourceList.forEach(function (item) {
          if (_this4.checkList.includes(item.value)) {
            item.selected = true;
          }
          if (item.selected) {
            _this4.allDataList_select.push(item);
          } else {
            _this4.allDataList.push(item);
          }
        });
        _this4.isLoading = false;
        // 清空check列表
        _this4.checkList = [];
        // 清空全选框状态
        _this4.isCheckAll = false;
        _this4.isCheckAll_select = false;
        // 向父组件返回结果
        _this4.callback();
      }, 50);
    },
    R2L: function R2L() {
      var _this5 = this;
      if (!this.checkList_select.length) return;
      this.isLoading = true;
      setTimeout(function () {
        // setTimeout延时避免加载图标显示不出来
        _this5.allDataList = [];
        _this5.allDataList_select = [];
        _this5.dataSourceList.forEach(function (item) {
          if (_this5.checkList_select.includes(item.value)) {
            item.selected = false;
          }
          if (item.selected) {
            _this5.allDataList_select.push(item);
          } else {
            _this5.allDataList.push(item);
          }
        });
        _this5.isLoading = false;
        // 清空check列表
        _this5.checkList_select = [];
        // 清空全选框状态
        _this5.isCheckAll = false;
        _this5.isCheckAll_select = false;
        // 向父组件返回结果
        _this5.callback();
      }, 50);
    },
    callback: function callback() {
      var _this6 = this;
      var val = this.allDataList_select.map(function (item) {
        return _this6.isOriginVal ? item : item.value;
      });
      this.$emit('onChange', val);
    },
    handleDragStart: function handleDragStart(item, e) {
      // 修复低版本火狐浏览器不能拖曳的问题
      e.dataTransfer.setData('data', null);
      // 设置当前拖曳节点的信息
      this.currItem = item;
    },
    cancelDefaultEvt: function cancelDefaultEvt(e) {
      // 使用原生的draggable属性需要禁止对应的接收元素的dragover默认事件
      e.preventDefault();
    },
    handleDragEnter: function handleDragEnter(item, e) {
      e.stopPropagation();
      this.currFocusItem = item;
    },
    handleDrop: function handleDrop(item, e) {
      var _this7 = this;
      e.stopPropagation();
      if (item.value && this.currItem.value && item.value !== this.currItem.value) {
        var targetIndex = this.dataSourceList.findIndex(function (i) {
          return i.value === _this7.currItem.value;
        });
        this.dataSourceList.splice(targetIndex, 1);
        var index = this.dataSourceList.findIndex(function (i) {
          return i.value === item.value;
        });
        this.dataSourceList.splice(index, 0, this.currItem);
        this.allDataList = [];
        this.allDataList_select = [];
        this.dataSourceList.forEach(function (item) {
          if (item.selected) {
            _this7.allDataList_select.push(item);
          } else {
            _this7.allDataList.push(item);
          }
        });
        this.callback();
      }
    },
    handleContentEnter: function handleContentEnter() {
      this.currFocusItem = {};
    },
    handleContentDrop: function handleContentDrop(e) {
      var _this8 = this;
      e.stopPropagation();
      var targetIndex = this.dataSourceList.findIndex(function (i) {
        return i.value === _this8.currItem.value;
      });
      this.dataSourceList.splice(targetIndex, 1);
      this.dataSourceList.push(this.currItem);
      this.allDataList = [];
      this.allDataList_select = [];
      this.dataSourceList.forEach(function (item) {
        if (item.selected) {
          _this8.allDataList_select.push(item);
        } else {
          _this8.allDataList.push(item);
        }
      });
      this.callback();
    }
  }
};